import React from 'react';
import { MemeRenderer } from '../meme/MemeComponents';
import type { MemeBlock } from '@/types/contentBlocks';

interface MemeBlockProps {
  block: MemeBlock;
  isDarkMode: boolean;
}

export const MemeBlockRenderer: React.FC<MemeBlockProps> = ({ block, isDarkMode }) => {
  const memeContent = JSON.stringify(block.data);
  return <MemeRenderer content={memeContent} isDarkMode={isDarkMode} />;
};
